import React, {ReactNode} from "react"

interface IProps {
    children: ReactNode
}

const LeftSideSpace: React.FC<IProps> = ({children}) => {

    return (
        <div className={'left_side_space_main'}>
            {children}
        </div>
    )
}

export default LeftSideSpace